"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AtlasInformationBanner["default"];
  }
});
var _AtlasInformationBanner = _interopRequireDefault(require("./AtlasInformationBanner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }